import styled from 'styled-components'

export const Div = styled.div`
  background-color: white;
  height: 35em;
  overflow: auto;
`
